import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMinusSquare, faPlusSquare} from "@fortawesome/free-solid-svg-icons";
import ConsignmentFromToDateTime from "../stolen/ConsignmentFromToDateTime";
import ConsignmentStatusBadge from "./ConsignmentStatusBadge";
import ConsignmentTrackingPortalButton from "./ConsignmentTrackingPortalButton";
import ConsignmentImagesGallery from "./ConsignmentImagesGallery";
import ConsignmentProofOfDeliveryButton from "./ConsignmentProofOfDeliveryButton";
import ConsignmentFreightTable from "./ConsignmentFreightTable";
import WaypointComponent from "../common/WaypointComponent";

interface ConsignmentListProps {
    consignments: CustomerAPIConsignmentResponse[];
    expandedIds: Set<number>;
    onToggleExpand: (consignmentId: number) => void;
}

const ConsignmentList = ({ consignments, expandedIds, onToggleExpand }: ConsignmentListProps) => {

    if (consignments.length < 1) {
        return (
            <div className="row">
                <div className="col-12">
                    <p className="text-center">No Deliveries found</p>
                </div>
            </div>
        )
    }

    return consignments.map(consignment => {
        const { delivery, freight } = consignment;
        const expanded = expandedIds.has(consignment.id);
        return (
            <React.Fragment key={consignment.id}>
                <div className="row">
                    <div className="col-1" onClick={() => onToggleExpand(consignment.id)}>
                        <FontAwesomeIcon icon={expanded ? faMinusSquare : faPlusSquare} size="lg"/>&nbsp;
                    </div>
                    <div className="col-3">
                        <strong>Date / Time</strong><br/>
                        <ConsignmentFromToDateTime fromDateTime={delivery.from} toDateTime={delivery.to}/>
                    </div>
                    <div className="col-4">
                        <strong>Delivery Reference</strong><br/>
                        {consignment.ref}
                    </div>
                    <div className="col-4">
                        <strong>Your Reference</strong><br />
                        {consignment.customerRef}
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <strong>To</strong><br />
                        <WaypointComponent waypoint={delivery} detailed={expanded} />
                    </div>
                    <div className="col-4">
                        <strong>Status</strong><br />
                        <p><ConsignmentStatusBadge consignment={consignment} /></p>
                    </div>
                    <div className="col-4">
                        <strong>Live Tracking</strong><br />
                        <ConsignmentTrackingPortalButton consignment={consignment} />
                    </div>
                </div>
                <div className="row">

                    <div className="col-6">
                        <ConsignmentFreightTable freight={freight} />
                    </div>

                    <div className="col-6">
                        {consignment.deliveryVehicle &&
                            <>
                                <div className="d-xl-none"><strong>Vehicle</strong><br /></div>
                                <div>
                                    {consignment.deliveryVehicle?.vehicleTypeDescription} <br />
                                    <pre>{consignment.deliveryVehicle?.registration}</pre>
                                </div>
                            </>
                        }
                    </div>

                </div>
                <div className="row">
                    <div className="12">
                        <ConsignmentImagesGallery consignment={consignment} hidden={!expanded} />
                    </div>
                </div>
                <div className="row">
                    <div className="12">
                        <ConsignmentProofOfDeliveryButton consignment={consignment} />
                    </div>
                </div>
                <hr />
            </React.Fragment>
        )

    })

}

export default ConsignmentList;
